export default "__VITE_ASSET__C1OLQkx8__"